import axios, {AxiosResponse} from 'axios'
import {API_URL} from '../../../../../_metronic/helpers'
import {DashboardActivitySnapshot, DashboardLiveSnapshot} from './_models'

const DASHBOARD_URL = `${API_URL}/dashboard`

export const getDashboardActivity = (
  refresh = false,
  signal?: AbortSignal
): Promise<DashboardActivitySnapshot> =>
  axios
    .get(`${DASHBOARD_URL}/activity`, {params: refresh ? {refresh: true} : undefined, signal})
    .then((response: AxiosResponse<DashboardActivitySnapshot>) => response.data)

export const getDashboardLive = (signal?: AbortSignal): Promise<DashboardLiveSnapshot> =>
  axios
    .get(`${DASHBOARD_URL}/live`, {signal})
    .then((response: AxiosResponse<DashboardLiveSnapshot>) => response.data)

export const getDashboardActivityQueryKey = (companyId: number) => ['dashboard-activity', companyId]

export const getDashboardLiveQueryKey = (companyId: number) => ['dashboard-live', companyId]

// The server keeps each business's activity for 30 s and its live read for 5 s, so polling
// faster than this would only return the same answer.
export const DASHBOARD_ACTIVITY_REFETCH_MS = 60_000
export const DASHBOARD_LIVE_ACTIVE_REFETCH_MS = 10_000
export const DASHBOARD_LIVE_IDLE_REFETCH_MS = 45_000

// A 400 (no business), 403 or 404 does not get better by retrying; a dropped connection may.
export const shouldRetryDashboardRead = (failureCount: number, error: unknown) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status || 0
    if (status >= 400 && status < 500) {
      return false
    }
  }

  return failureCount < 2
}

// Never renders a raw server answer: only the dashboard's own readable message, or the fallback.
export const readDashboardError = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as {message?: unknown} | undefined
    if (typeof data?.message === 'string' && data.message.trim()) {
      return data.message.trim()
    }
  }

  return fallback
}
